import { Component, effect } from '@angular/core';
import { UserService } from '../../user.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { UserInfo } from '../../user-info/user-info';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CommunityCalendar } from '../community-calendar/community-calendar';
import { PaymentsOverview } from '../payments-overview/payments-overview';
import { MyWorkOrdersComponent } from '../../my-work-orders/my-work-orders.component';

@Component({
  selector: 'app-property-overview-widget',
  imports: [CommonModule, FormsModule, RouterOutlet, RouterLink, RouterLinkActive, UserInfo, CommunityCalendar, PaymentsOverview, MyWorkOrdersComponent	],
  templateUrl: './property-overview-widget.html',
  styleUrl: './property-overview-widget.scss'
})
export class PropertyOverviewWidget {
	public safeMapUrl: SafeResourceUrl | undefined;

	protected language: number = 1;

	constructor(protected userService: UserService, protected sanitizer: DomSanitizer) {
		effect(() => {
			const tenant = this.userService.currentTennant();
			this.language = tenant ? tenant.Language : 1;
			
			//const mapUrl = "www.google.com/maps?q=" + this.userService.currentTennant()?.Region + ", " + this.userService.currentTennant()?.City + ", " + this.userService.currentTennant()?.Address + "&output=embed";
			let mapUrl = this.userService.currentTennant()?.Google_map;
			//www.google.com/maps/place/
			if( mapUrl.startsWith('http://') ){
				//remove http://
				mapUrl = mapUrl.replace('http://', '');
			}
			if( mapUrl.startsWith('https://') ){
				//remove https://
				mapUrl = mapUrl.replace('https://', '');
			}
			if (mapUrl.startsWith('www.google.com/maps/place/')) {
				mapUrl = mapUrl.replace('www.google.com/maps/place/', '');
			}

			if (mapUrl) {
				this.safeMapUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://' + 'www.google.com/maps?q=' + mapUrl + '&output=embed');
			}

		});
	}

	contentStrings : Record<string, Record<number, string>> = {
		MyMCXPortal: { 1: "My MCX Portal", 2: "マイMCXポータル" },
		CommunityCalendar: { 1: "Community Calendar", 2: "コミュニティカレンダー" },
		PaymentsOverview: { 1: "Payments Overview", 2: "支払い概要" },
		PropertyOverview: { 1: "Property Overview", 2: "物件概要" },
		MyResidence: { 1: "My Residence", 2: "私の住居" },
		Name: { 1: "Name", 2: "名前" },
		Phone: { 1: "Phone", 2: "電話" },
		Email: { 1: "Email", 2: "メール" },
		UnitNo: { 1: "Unit No.", 2: "部屋番号" },
		Address: { 1: "Address", 2: "住所" },
		City: { 1: "City", 2: "市" },
		Region: { 1: "Region", 2: "地域" },
	}
}